import React from 'react'

export type AccordionContextValue = {
  handleToggle?: () => void
  isDisabled: boolean
  isOpen: boolean
}

const INITIAL_CONTEXT: AccordionContextValue = {
  isDisabled: false,
  isOpen: false,
}

export const AccordionContext =
  React.createContext<AccordionContextValue>(INITIAL_CONTEXT)
